import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MobileService } from '@platform-frontend/ui-tools';

@Component({
  selector: 'yat-mobile-draw-dialog',
  templateUrl: './mobile-draw-dialog.component.html',
  styleUrls: ['./mobile-draw-dialog.component.scss']
})
export class MobileDrawDialogComponent implements OnInit, OnDestroy {
  constructor(private readonly mobileService: MobileService) {}

  @Input()
  showSecondConfirmDialogFlag: boolean = false;

  @Input()
  isSignedIn: boolean | null = false;

  @Input()
  email: string | null = '';

  @Output()
  abortConfirmModal: EventEmitter<void> = new EventEmitter();

  @Input()
  showDialog: boolean = false;

  private isDragging = false;
  private startY = 0;
  private currentY = 0;

  isMobile(): boolean {
    return this.mobileService.isMobileScreenSize();
  }

  ngOnInit(): void {
    document.addEventListener('keydown', this.onKeyPress);
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.onKeyPress);
  }

  abortConfirmDelete(): void {
    this.showDialog = false;
    this.abortConfirmModal.emit();
  }

  onKeyPress = (event: KeyboardEvent): void => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.abortConfirmDelete();
    }
  };

  @HostListener('touchstart', ['$event'])
  onTouchStart = (event: TouchEvent): void => {
    const targetElement = event.target as HTMLElement;
    const drawerElement = targetElement.closest('.icons-mobile');

    if (!drawerElement) {
      event.stopPropagation();
      return;
    }

    this.isDragging = true;
    this.startY = event.touches[0].clientY;
    this.currentY = this.startY;

    document.addEventListener('touchmove', this.onTouchMove);
    document.addEventListener('touchend', this.onTouchEnd);
  };

  onTouchMove = (event: TouchEvent): void => {
    if (!this.isDragging) return;
    this.currentY = event.touches[0].clientY;
    const deltaY = this.currentY - this.startY;
    if (deltaY > 0) {
      const confirmDialog = document.querySelector('.icons-mobile') as HTMLElement;
      if (confirmDialog) {
        confirmDialog.style.transform = `translateY(${deltaY}px)`;
      }
    }
  };

  onTouchEnd = (): void => {
    if (!this.isDragging) return;
    this.isDragging = false;
    document.removeEventListener('touchmove', this.onTouchMove);
    document.removeEventListener('touchend', this.onTouchEnd);

    const deltaY = this.currentY - this.startY;
    const confirmDialog = document.querySelector('.icons-mobile') as HTMLElement;
    if (confirmDialog) {
      confirmDialog.style.transform = '';
    }

    if (deltaY > 50) {
      this.abortConfirmDelete();
    }
  };
}
